class OzAPIPath {
  protected static readonly apiPaths = {
    // AUTHENTICATE
    AUTHORIZE_AUTH: "/api/authorize/auth",

    TOKEN_RENEWAL: "/api/authorize/refresh",

    // FOLDERS
    FOLDERS: "/api/folders/",
  };

  // Dynamic path builders (functions)
  protected static readonly dynamicPathGenerators = {
    ANALYSES_RESULT_BY_TRANSACTION_ID: (transactionId: string) =>
      `/api/folders/?meta_data=transaction_id==${transactionId}&with_analyses=true`,

    UPLOAD_MEDIA_BY_FOLDER_ID: (folderId: string): string =>
      `/api/folders/${folderId}/media`,

    ANALYSES_FOLDER_BY_FOLDER_ID: (folderId: string): string =>
      `/api/folders/${folderId}/analyses`,

    POLL_ANALYSES_BY_ANALYSIS_ID: (analysisId: string): string =>
      `/api/analyses/${analysisId}`,
  };

  public static getApiPath(PATH_CONSTANT: keyof typeof OzAPIPath.apiPaths) {
    return OzAPIPath.apiPaths[PATH_CONSTANT];
  }

  public static getDynamicPath<
    K extends keyof typeof OzAPIPath.dynamicPathGenerators
  >(PATH_GENERATOR: K, params: string) {
    return OzAPIPath.dynamicPathGenerators[PATH_GENERATOR](params);
  }
}
export default OzAPIPath;
